"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeLagMeterBootstrap = exports.returnControlToEventLoop = void 0;
exports.mapAsync = mapAsync;
exports.reduceAsync = reduceAsync;
exports.filterAsync = filterAsync;
exports.someAsync = someAsync;
const numIterToCallBlockingFn = 100;
const makeBlockingFn = () => {
    let counter = 0;
    return async () => {
        counter++;
        if (counter === numIterToCallBlockingFn) {
            counter = 0;
            await new Promise((resolve) => setImmediate(resolve));
        }
    };
};
exports.returnControlToEventLoop = makeBlockingFn();
async function mapAsync(array, callback) {
    const result = [];
    for (const item of array) {
        result.push(await callback(item));
        await (0, exports.returnControlToEventLoop)();
    }
    return result;
}
async function reduceAsync(array, callback, initialValue) {
    let accumulator = initialValue;
    for (const item of array) {
        accumulator = await callback(accumulator, item);
        await (0, exports.returnControlToEventLoop)();
    }
    return accumulator;
}
async function filterAsync(array, callback) {
    const result = [];
    for (const item of array) {
        if (await callback(item)) {
            result.push(item);
        }
        await (0, exports.returnControlToEventLoop)();
    }
    return result;
}
async function someAsync(array, callback) {
    for (const item of array) {
        await (0, exports.returnControlToEventLoop)();
        if (await callback(item)) {
            return true;
        }
    }
    return false;
}
const nodeLagMeterBootstrap = (logger) => {
    let shutdown = false;
    let timestamp = Date.now();
    let timeoutId;
    const nodeLagMeter = (logger) => {
        if (shutdown) {
            return;
        }
        timestamp = Date.now();
        timeoutId = setTimeout(() => {
            const deviationMs = Date.now() - timestamp - 1000;
            const message = "Node Lag Meter: " + deviationMs + " ms";
            if (deviationMs > 1_000) {
                logger.warn(message);
            }
            if (deviationMs > 15_000) {
                logger.error(message, {});
            }
            nodeLagMeter(logger);
        }, 1000);
    };
    nodeLagMeter(logger);
    return () => {
        clearTimeout(timeoutId);
        shutdown = true;
    };
};
exports.nodeLagMeterBootstrap = nodeLagMeterBootstrap;
//# sourceMappingURL=async.js.map